// CMS path: sitecore/content/Sites/JCRW/Simulcast/Carnivals/{carnivalPage}/{carnivalTab}
export const carnivalTabTemplate = {
  ID: "39F06434-2C10-4385-BCC5-E40C21C3EF4A",
  NAME: "CarnivalTab",
  SECTION_A: {
    ID: "E50CEC73-FCA3-4CF0-BD33-0FC609612C7B",
    NAME: "Text_Image",
  },
  SECTION_B: {
    ID: "387D0313-7008-483F-81EB-EF3439D55A9E",
    NAME: "Image",
  },
  SECTION_C: {
    ID: "9DEF3ED3-4301-416A-A71D-B6EEFDB3FAD9",
    NAME: "Key_Contenders",
  }
}

// CMS path: sitecore/content/Sites/JCRW/Simulcast/Carnivals
export const carnivalTemplate = {
  ID: "1818035A-22D1-4F94-BDAA-AE3A354C8F8F",
  NAME: "CarnivalPage",
  CARNIVAL_TAB: carnivalTabTemplate,
}

// CMS path: sitecore/content/Sites/JCRW/Meetings/Simulcast/{season}/{meetingId}/InPageDisplayButtons
export const inPageDisplayButtonsTemplate = {
  ID: "102FFD2416AB4D869EAC8F83717E5F78",
  NAME: "InPageDisplayButtons",
  ARTICLE_BUTTON: {
    ID: "4BEB4EE65CCE4A60B2E9B79EEBF7C1E9",
    NAME: "ArticleButton"
  },
  MULTIPLE_PHOTO_BUTTON: {
    ID: "7207869B729247749A44AE0CE4B33A22",
    NAME: "MultiplePhotoButton"
  },
  PDF_BUTTON: {
    ID: "1CA8BF1009AB41D29DB0AA502D1951D3",
    NAME: "PDFButton"
  },
  URL_BUTTON: {
    ID: "E6E84D62171A4119B68ADC3F77E4AE79",
    NAME: "URLButton"
  },
  VIDEO_BUTTON: {
    ID: "A81B5E7A497C446B91F6B70A3A4FABC9",
    NAME: "VideoButton"
  },
  SINGLE_PHOTO_BUTTON: {
    ID: "1A161A61-46D8-4692-B478-640D88C2F979",
    NAME: "SinglePhotoButton"
  }
}

// CMS path: sitecore/content/Sites/JCRW/Meetings/Simulcast/{season}/{meetingId}/JockeysTrainersRankings
export const jockeysTrainersRankingsTemplate = {
  ID: "C6C85622BC8C4AD1AA97EB7FCB05A803",
  NAME: "JockeysTrainersRankings",
  JOCKEYS_TRAINERS_RANKING: {
    ID: "3861039FA3644CE8957AE13A2B8E9689",
    NAME: "JockeysTrainersRanking"
  }
}

// CMS path: sitecore/content/Sites/JCRW/Meetings/Simulcast/{season}/{meetingId}/PastWinners
export const pastWinnersTemplate = {
  ID: "A060CB0E09BE4317AD91245C9C885DE4",
  NAME: "PastWinners",
  PAST_WINNER: {
    ID: "F9953DFAF2A544F3B1AC3CE59F629F99",
    NAME: "PastWinner"
  }
}

// CMS path: sitecore/content/Sites/JCRW/Meetings/Simulcast/{season}/{meetingId}/Races/{race}
export const raceTemplate = {
  ID: "D7DAF28D575C4EA08983447449874713",
  NAME: "Race",
  PAST_WINNERS: pastWinnersTemplate,
  // CMS path: sitecore/content/Sites/JCRW/Meetings/Simulcast/{season}/{meetingId}/Races/{race}/Entries
  ENTRIES: {
    ID: "D28C1A7DE27245A3BD0FEC767C970347",
    NAME: "Entries"
  },
  // CMS path: sitecore/content/Sites/JCRW/Meetings/Simulcast/{season}/{meetingId}/Races/{race}/ReferenceOdds
  REFERENCE_ODDS: {
    ID: "F20A07DE5C85471EB78101571B42C5DC",
    NAME: "ReferenceOdds",
  }
}

// CMS path: sitecore/content/Sites/JCRW/Meetings/Simulcast/{season}/{meetingId}/Races
export const racesTemplate = {
  ID: "7AADC074D6214575A75C808AA390D754",
  NAME: "Races",
  RACE: raceTemplate,
}

// CMS path: sitecore/content/Sites/JCRW/Meetings/Simulcast/{season}/{meetingId}
export const meetingTemplate = {
  ID: "A9BC4CDDB7C2444E8BBD7FB648E0C6F4",
  NAME: "MeetingDate",
  JOCKEYS_TRAINERS_RANKINGS: jockeysTrainersRankingsTemplate,
  RACES: racesTemplate,
  TRACK_ANALYSIS: {
    ID: "EBC5BB38D8184471943A7DEF620B23EF",
    NAME: "TrackAnalysis"
  },
  IN_PAGE_DISPLAY_BUTTONS: inPageDisplayButtonsTemplate,
}

// CMS path: sitecore/content/Sites/JCRW/Meetings/Simulcast/{season}
export const seasonTemplate = {
  ID: "AC57B7450DB149C2823AEA42CD29A8E8",
  NAME: "SimulcastSeasonFolder",
  MEETING: meetingTemplate,
}